import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const contacts = {
  updateContactDepartments: lazyModuleMethod(
    () => import('./updateContactDepartments'),
    'default'
  ),
  updateContactPerson: lazyModuleMethod(
    () => import('./updateContactPerson'),
    'default'
  ),
  updateContactPersons: lazyModuleMethod(
    () => import('./updateContactPersons'),
    'default'
  ),
}
